<template>
  <section>
    <div v-if="loading">

      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
          <app-icon
            v-bind:name="'search'"
            v-bind:classname="'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'"
          ></app-icon>
          <input
            type="text"
            class="input w-full sm:w-64 box px-10 text-gray-700"
            placeholder="Buscar por nombre"
            v-model="filter.name"
          />
          <div
            class="inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
          >
            <app-icon
              v-bind:name="'chevron-down'"
              v-bind:classname="'dropdown-toggle w-4 h-4 cursor-pointer text-gray-700'"
            ></app-icon>
            <div
              class="inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
            >
              <div class="dropdown-box__content box p-5">
                <div class="grid grid-cols-12 gap-4 row-gap-3">
                  <div class="col-span-6">
                    <div class="text-xs">Cuenta</div>
                    <select
                      class="input w-full border mt-2 flex-1"
                      v-model="filter.account"
                      required
                    >
                      <option disabled selected>Seleccione la cuenta</option>
                      <option
                        v-for="account in accounts"
                        v-bind:key="account.id"
                        v-bind:value="account.id"
                      >
                        {{ account.name }} - {{ account.country.prefix }}
                      </option>
                      <option value="">Todos</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full sm:w-auto flex">
            <a data-target="#hour" data-toggle="modal" class="button text-white bg-theme-1 shadow-md mr-2">Crear Horas Soporte</a>
        </div>
      </div>
      <!-- END: Filter -->

      <!-- Edit -->
      <div class="intro-y box mt-6" v-if="boxedit">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
              Editar Hora de Soporte
          </h2>
        </div>
        <form  @submit.prevent="updateHour">
        <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
          <div class="col-span-4 sm:col-span-4">
              <label>Cuenta:</label>
              <input type="text" class="input w-full border mt-2 flex-1"
                :value="hour.account.name+' - '+hour.account.country.prefix" disabled>
          </div>
          <div class="col-span-4 sm:col-span-4">
              <label>Equipo:</label>
              <input type="text" class="input w-full border mt-2 flex-1"
                :value="hour.team.name" disabled>
          </div>
          <div class="col-span-4 sm:col-span-4">
              <label>Horas Por Semana:</label>
              <input v-on:input="updateValue('hours',$event)" type="text" class="input w-full border mt-2 flex-1"
                :value="hour.hours" required>
          </div>
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
            <button type="button" v-on:click="closeEditHour()" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
            <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Modificar</button>
        </div>
        </form>
      </div>
      <!-- END: Edit -->

      <!-- List -->
      <div class="intro-y grid grid-cols-12 mt-5">

        <div class="col-span-12 sm:col-span-6 xxl:col-span-6 p-2" v-for="account in filteredAccounts">
          <div class="pos__ticket box p-2 mt-5">
            <span class="flex items-center p-3 transition duration-300 ease-in-out bg-theme-2 hover:bg-gray-200 rounded-md">
                <div class="pos__ticket__item-name truncate mr-1">{{account.name}} - {{account.country.prefix}}</div>
            </span>
            <a v-on:click="editHour(hour)" v-if="hour.account_id === account.id" v-for="hour in hours" class="flex items-center p-3 cursor-pointer transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                <div class="pos__ticket__item-name truncate mr-1">{{hour.team.name}}</div>
                <app-icon v-bind:name="'edit'" v-bind:classname="'w-4 h-4 mr-2'"></app-icon>
                <div class="text-xs text-gray-400">{{ hour.period.start_date }} - {{ hour.period.finish_date }}</div>
                <div class="ml-auto">{{hour.hours}}</div>
            </a>
          </div>
        </div>
      </div>
      <!-- END: List -->

    </div>

    <div v-else>
      <app-loading></app-loading>
    </div>

    <!-- Modal -->
    <div class="modal" id="hour">
        <div class="modal__content modal__content--sm">
          <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
            <h2 class="font-medium text-base mr-auto">
                Crear Horas de Soporte
            </h2>
          </div>
          <form  @submit.prevent="createHour">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-12 sm:col-span-12">
                <label>Cuenta</label>
                <select class="input w-full border mt-2 flex-1" v-model="hour.account_id" required>
                    <option disabled>Seleccione la cuenta</option>
                    <option v-for="account in accounts" v-bind:value="account.id">
                      {{account.name}} - {{account.country.prefix}}
                    </option>
                </select>
            </div>
            <div class="col-span-12 sm:col-span-12">
                <label>Equipo</label>
                <select class="input w-full border mt-2 flex-1" v-model="hour.team_id" required>
                    <option disabled>Seleccione el equipo</option>
                    <option v-for="team in teams" v-bind:value="team.id">
                      {{team.name}}
                    </option>
                </select>
            </div>
            <div class="col-span-12 sm:col-span-12">
                <label>Horas Por Semana:</label>
                <input  type="number" class="input w-full border mt-2 flex-1" v-model="hour.hours" required>
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
              <button type="button" data-dismiss="modal" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
              <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Crear</button>
          </div>
          </form>
        </div>
    </div>
    <!-- Modal End -->

  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AdminListHour',
  data () {
    return {
      loading: false,
      boxedit: false,
      hour: {
        name: '',
        status: '',
        entity: 'hour'
      },
      hour_current: {},
      filter: {
        name: '',
        account: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      hours: 'getHours',
      accounts: 'getAccounts',
      teams: 'getTeams'
    }),
     filteredAccounts: function () {
      return this.accounts.filter((item) => {
        let name = this.filter.name ? item.name
            .toLowerCase()
            .includes(this.filter.name.toLowerCase()) : true
        let account_id = this.filter.account
          ? item.id === this.filter.account
          : true
        return name && account_id
      })
    },
  },
  beforeMount () {
    //SEND ENTITY AND MUTATION
    this.getAll('hour')
    .then(() => {
      this.loading = true
    }),
    this.getList('account')
    .then(() => {
      this.loading = true
    })
  },
  methods: {
    createHour () {
      var vm = this
      window.$('#create').button('loading')
      vm.store(vm.hour).then(item => {
        window.$('#hour').modal('hide')
        vm.hour = { name: '', entity: 'hour' }
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/hours')
        window.$('#create').button('reset')
      })
      .catch(error => {
        window.$('#create').button('reset')
        vm.hour = { name: '', entity: 'hour' }
      })
    },
    removeHour: function (value) {
      var vm = this
      vm.form = {
        id : value.id,
        entity : 'hour'
      }
      vm.loading = false
      vm.remove(vm.form).then(item => {
        vm.loading = true
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/hours')
      })
      .catch(message => {
        vm.loading = true
      })
    },
    editHour: function (value) {
      this.boxedit = true
      this.hour = value
    },
    closeEditHour: function () {
      this.boxedit = false
      this.hour_current = {}
    },
    updateHour: function (value) {
      var vm = this
      vm.form = {
        id : vm.hour.id,
        entity : 'hour',
        hours: vm.hour_current.hours
      }
      vm.loading = false
      vm.update(vm.form).then(item => {
        vm.loading = true
        vm.boxedit = false
        vm.hour = { name: '', entity: 'hour' }
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/hours')
      })
      .catch(message => {
        vm.loading = true
      })
    },
    updateValue (attribute, e) {
      this.hour_current[attribute] = e.target.value
    },
    ...mapActions([
      'getAll',
      'getList',
      'remove',
      'store',
      'update'
    ])
  },
  components: {
    appIcon: Icon,
    appLoading: Loading
  }
}
</script>



// WEBPACK FOOTER //
// ListHour.vue?3c4574d0